/**
 * Identity-reset helper for the logout flow.
 *
 * Centralizes the one place outside the provider tree that needs to
 * talk to posthog-js: ``src/lib/api/auth.ts`` calls ``resetIdentity()``
 * between ``apiLogout()`` and ``setCSRFToken(null)`` so the next
 * session starts with a fresh distinct_id and no lingering group
 * attachment. See ``plans/PLAN_POSTHOG_01_FOUNDATIONS.md`` § "Logout
 * flow integration".
 *
 * Why this exists instead of an inline ``posthog.reset()`` in auth.ts:
 * a future lint rule (PR-4) will forbid direct ``posthog-js`` imports
 * outside ``src/lib/observability/`` to keep the SDK surface area
 * contained. Routing through this helper means auth.ts stays
 * lint-clean and the SDK module boundary is honoured.
 *
 * ``posthog.reset()`` is idempotent and safe to call when ``init()``
 * has not run yet — it just clears whatever in-memory state exists.
 */

import posthog from "posthog-js";

export function resetIdentity(): void {
  posthog.reset();
}
